import styled from "styled-components";

export const ChatFrameActionsContainer = styled.div`
  position: absolute;
  align-items: center;
  bottom: 0;
  z-index: 2;
  transform: translatey(100%);
`
